
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Heading, Stack } from "@chakra-ui/layout"
import { H3 } from 'src/typography/typography'

function ContentfulDocument({ title, document }) {
  return (
    <Stack
      layerStyle='appContainer'
      maxW='container.md'
      spacing='md'
    >
      <H3
        as='h1'
        mt={10}
      >
        {title}
      </H3>
      {documentToReactComponents(document)}
    </Stack>
  )
}

export default ContentfulDocument
